import { createAction, props } from '@ngrx/store';
import { Brand } from '../../../../models/Prodotto';
import { HttpStatus } from '../../../../models/http-status';

const area = '[Products / Brands]'

/**
 * Get records actions
 */

export const loadRecords = createAction(
    `${area} Load records`,
    props<{ reload?: boolean }>()
);

export const loadRecordsSuccess = createAction(
    `${area} Load records success`,
    props<{ records: Brand[] }>()
);

export const loadRecordsFail = createAction(
    `${area} Load records fail`,
    props<any>()
);

export const saveRecord = createAction(
    `${area} Save record`,
    props<{ record: Brand }>()
);

/**
 * Add record actions
 */

export const addRecord = createAction(
    `${area} Add record`,
    props<{ record: Brand }>()
);

export const addRecordSuccess = createAction(
    `${area} Add record success`,
    props<{ record: Brand }>()
);

/**
 * Update record actions
 */

export const updateRecord = createAction(
    `${area} Update record`,
    props<{ record: Brand }>()
);

export const updateRecordSuccess = createAction(
    `${area} Update record success`,
    props<{ record: Brand }>()
);

/**
 * Delete record actions
 */

export const deleteRecord = createAction(
    `${area} Delete record`,
    props<{ id: number }>()
);

export const deleteRecordSuccess = createAction(
    `${area} Delete record success`,
    props<{ id: number }>()
);

/**
 * Il backend risponde 422 se il brand ha prodotti collegati: il messaggio
 * va mostrato, non ingoiato.
 */
export const deleteRecordFail = createAction(
    `${area} Delete record fail`,
    props<{ message: string }>()
);

export const clearDeleteError = createAction(
    `${area} Clear delete error`,
);

/**
 * Modal
 */

export const showModal = createAction(
    `${area} Open modal`,
    props<{ id?: number }>()
);

export const closeModal = createAction(
    `${area} Close modal`,
);
